import { GiLockedChest, GiMilleniumKey } from "react-icons/gi";
import { LuSettings2, LuKey } from "react-icons/lu";
import { TiArrowUpOutline, TiArrowDownOutline } from "react-icons/ti";
import { isMobile } from "react-device-detect";
import { ePlanIdentifier } from "../../../../@types/Billing/Plan";

interface IBillingState {
  planName: string;
  totalMade: number;
  totalRemaining: number;
}

interface IReaction {
  title: string;
  description: string;
  actionText: string | null;
  actionHref: string | null;
}

const TrialComponent = ({ billingState }: { billingState: IBillingState }) => {
  const { title, description, actionText, actionHref } = getReaction(
    billingState.planName
  );

  return (
    <div className="trial-component">
      <div className="media media-dashboard-one">
        <div className="media-body d-none d-lg-block">
          <div className="card card-dashboard-thirteen">
            <h3>Impressões de nossa inteligência artificial.</h3>
            <p className="az-content-text">
              Abaixo você tem uma lista de impressões que a Lucy relatou sobre
              este ativo.
            </p>
            <div className="animated fadeInDown">
              <div className="row">
                {Array(6)
                  .fill(0)
                  .map((_, i) => (
                    <TrialImpressionsItem key={i} index={i} />
                  ))}
              </div>
            </div>
            <div className="d-flex flex-row justify-content-center">
              <div className="chart-legend" style={{ whiteSpace: "normal" }}>
                <div>Ótimo</div>
                <div>Bom</div>
                <div>Alerta</div>
                <div>Perigo</div>
              </div>
            </div>
          </div>
        </div>
        <div className="media-right">
          <TrialSummaryItem />
        </div>
      </div>
      <div className="blured-layer">
        <h2>{title}</h2>
        <p className="trial-message">{description}</p>
        {actionHref && actionText && (
          <a href={actionHref} className="fancy-button bg-gradient2">
            <span>
              <LuKey size={22} /> {actionText}
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

export default TrialComponent;

const TrialImpressionsItem = ({ index }: { index: number }) => {
  return (
    <div
      className={
        isMobile
          ? index === 0
            ? "col-md-4 col-sm-6 col-xs-6 mg-t-0"
            : "col-md-4 col-sm-6 col-xs-6 mg-t-20"
          : index < 3
            ? "col-md-4 col-sm-6 col-xs-6"
            : "col-md-4 col-sm-6 col-xs-6 mg-t-20"
      }
    >
      <div className="animated fadeInDown">
        <div className="media">
          <div
            className="media-icon"
            style={{ color: index % 2 === 0 ? "#fde896" : "#66bb6a" }}
          >
            {index % 2 === 0 ? (
              <GiMilleniumKey size={32} />
            ) : (
              <GiLockedChest size={32} />
            )}
          </div>
          <div className="media-body">
            <h6>Bloqueado</h6>
            <label>Faça uma assinatura</label>
          </div>
        </div>
        <span>
          Aqui você verá uma descrição sobre essa impressão específica. Faça uma assinatura para usufruir deste recurso.
        </span>
      </div>
    </div>
  );
};

const TrialSummaryItem = () => {
  const arrWithAnalysisType = [
    {
      name: "Avaliações importante",
      qntBuy: 0,
      qntSell: 0,
    },
    {
      name: "Saúde do ativo",
      qntBuy: 0,
      qntSell: 0,
    },
    {
      name: "Análise fundamentalista",
      qntBuy: 0,
      qntSell: 0,
    },
    {
      name: "Análise técnica",
      qntBuy: 0,
      qntSell: 0,
    },
  ];

  return (
    <div
      className="card card-minimal-one"
      id={!isMobile ? "analysis-step-7" : ""}
    >
      <div className="card-body animated fadeInDown">
        <label style={{ color: "var(--primary-blue)" }}>
          Análise rápida
          <button type="button" className="unstyled-btn settings-btn">
            <LuSettings2 size={18} />
          </button>
        </label>
        {
          //Bigger indications
          <h6>
            <label>
              <span style={{ color: "#66bb6a" }}>
                <TiArrowUpOutline />X{" "}
              </span>
              Fatores de compra
            </label>
          </h6>
        }
        {
          //Less Indications
          <p className="tx-18" style={{ marginLeft: 7 }}>
            <label>
              <span style={{ color: "#ef5350" }}>
                <TiArrowDownOutline />X{" "}
              </span>
              Fatores de venda
            </label>
          </p>
        }

        <div>
          {
            //Results by category
            arrWithAnalysisType.map((item, i) => {
              return (
                <p className="invoice-info-row" key={i}>
                  <span>{item.name}</span>

                  {item.qntBuy === -1 && item.qntSell === -1 ? (
                    <span style={{ color: "var(--text-7)", fontWeight: 500 }}>
                      OFF
                    </span>
                  ) : (
                    <span style={{ color: "#4caf50" }}>
                      {
                        //Strong font if it has bigger than the sell
                        item.qntBuy > item.qntSell ? (
                          <b>{item.qntBuy}</b>
                        ) : (
                          item.qntBuy
                        )
                      }
                      <span style={{ color: "#000000" }}>{" | "}</span>
                      {
                        //Strong font if it has big than buy
                        <span style={{ color: "#f44334" }}>
                          {item.qntSell > item.qntBuy ? (
                            <b>{item.qntSell}</b>
                          ) : (
                            item.qntSell
                          )}
                        </span>
                      }
                    </span>
                  )}
                </p>
              );
            })
          }

          <p className="mg-t-15 tx-12">
            Segundo análise feita por nossa <b>I.A</b> com base no seu perfil de
            investidor atual, a recomendação da
            <b> Lucy</b> é de{" "}
            <b style={{ color: "#66bb6a" }}>Aderir a um plano.</b>
          </p>
          <p className="tx-10 text-center" style={{ color: "gray" }}>
            A análise acima reflete apenas dados visuais sem nada de real.
            Experimente uma assinatura para ter acesso a análises reais.
          </p>
        </div>
      </div>
    </div>
  );
};

function getReaction(planIdentifier: string): IReaction {
  if (planIdentifier === ePlanIdentifier.FREE) {
    return {
      title: "Você atingiu o limite de análises do seu plano. 😭",
      description:
        "Você está no plano gratuito e suas análises grátis acabaram. Te oferecemos um desconto imperdível na adesão do nosso plano básico e você desbloqueia mais 120 análises.",
      actionText: "Ver oferta",
      actionHref: "/billing",
    };
  }

  if (
    planIdentifier === ePlanIdentifier.BRONZE_MENSAL ||
    planIdentifier === ePlanIdentifier.BRONZE_ANUAL
  ) {
    return {
      title: "Você atingiu o limite de análises do seu plano. 😭",
      description:
        "Infelizmente, você chegou ao limite de análises do seu plano atual. Esse limite é renovado no início de cada mês automaticamente e você pode voltar a realizar análises. Você pode atualizar para um plano com um limite maior e reiniciar seu limite tocando no botão abaixo.",
      actionText: "Atualizar plano",
      actionHref: "/plan-update",
    };
  }

  if (
    planIdentifier === ePlanIdentifier.PRATA_MENSAL ||
    planIdentifier === ePlanIdentifier.PRATA_ANUAL
  ) {
    return {
      title: "Você atingiu o limite de análises do seu plano. 😭",
      description:
        "Infelizmente, você chegou ao limite de análises do seu plano atual. Esse limite é renovado no início de cada mês automaticamente e você pode voltar a realizar análises. Você pode atualizar para um plano com um limite maior e reiniciar seu limite tocando no botão abaixo.",
      actionText: "Atualizar plano",
      actionHref: "/plan-update",
    };
  }

  if (
    planIdentifier === ePlanIdentifier.OURO_MENSAL ||
    planIdentifier === ePlanIdentifier.OURO_ANUAL
  ) {
    return {
      title: "Você atingiu o limite de análises do seu plano. 😭",
      description:
        "Infelizmente, você chegou ao limite de análises do seu plano atual. Esse limite é renovado no início de cada mês automaticamente e você pode voltar a realizar análises. Caso você precise de um limite especial maior que seu limite atual, por favor, entre em contato conosco pelo e-mail suporte@fatores.ai",
      actionText: null,
      actionHref: null,
    };
  }

  return {
    title: "Você atingiu o limite de análises do seu plano. 😭",
    description:
      "Você está no plano gratuito e suas análises grátis acabaram. Te oferecemos um desconto imperdível na adesão do nosso plano básico e você desbloqueia mais 120 análises.",
    actionText: "Ver oferta",
    actionHref: "/billing",
  };
}
